import React from "react";

export function AvatarOverlayLayer({ registry, renderAvatar }) {
  const leftAvatars = [registry?.linc].filter(Boolean);
  const rightAvatars = [registry?.arti, ...(registry?.departmentHeads || [])].filter(Boolean);

  return (
    <div className="lw-avatar-layer" aria-label="Assistant and department head overlay layer">
      <div className="lw-avatar-safe-zone lw-avatar-safe-zone--left" data-avatar-zone="system-assistants">
        {renderAvatar ? leftAvatars.map((avatar) => renderAvatar(avatar, "left")) : null}
      </div>
      <div className="lw-avatar-safe-zone lw-avatar-safe-zone--right" data-avatar-zone="creative-and-department-heads">
        {renderAvatar ? rightAvatars.map((avatar) => renderAvatar(avatar, "right")) : null}
      </div>
    </div>
  );
}
